module.exports = "//d2t2kh5dwcod2h.cloudfront.net/7b14e621b76e9e6721f6ed72e31bd46b4093c3cd/images/photo-couple-wide.png";